import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import UseFormControl from './UseFormControl';
import ClientProvider from './client';
export default createDemo(import.meta.url, UseFormControl, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/text-fields/demos/use-form-control/UseFormControl.tsx",
    "fileName": "UseFormControl.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport FormControl, { useFormControl } from '@mui/material/FormControl';\nimport OutlinedInput from '@mui/material/OutlinedInput';\nimport FormHelperText from '@mui/material/FormHelperText';\n\nfunction MyFormHelperText() {\n  const { focused } = useFormControl() || {};\n\n  const helperText = React.useMemo(() => {\n    if (focused) {\n      return 'This field is being focused';\n    }\n\n    return 'Helper text';\n  }, [focused]);\n\n  return <FormHelperText>{helperText}</FormHelperText>;\n}\n\nexport default function UseFormControl() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <form noValidate autoComplete=\"off\">\n      <FormControl sx={{ width: '25ch' }}>\n        <OutlinedInput placeholder=\"Please enter text\" />\n        <MyFormHelperText />\n      </FormControl>\n    </form>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 29,
        "focusedLines": 6,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport FormControl, { useFormControl } from '@mui/material/FormControl';\nimport OutlinedInput from '@mui/material/OutlinedInput';\nimport FormHelperText from '@mui/material/FormHelperText';\n\nfunction MyFormHelperText() {\n  const { focused } = useFormControl() || {};\n\n  const helperText = React.useMemo(() => {\n    if (focused) {\n      return 'This field is being focused';\n    }\n\n    return 'Helper text';\n  }, [focused]);\n\n  return <FormHelperText>{helperText}</FormHelperText>;\n}\n\nexport default function UseFormControl() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <form noValidate autoComplete=\"off\">\n      <FormControl sx={{ width: '25ch' }}>\n        <OutlinedInput placeholder=\"Please enter text\" />\n        <MyFormHelperText />\n      </FormControl>\n    </form>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 22
            },
            [
              "    <",
              [
                "span",
                "pl-ent",
                "form"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "noValidate"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "autoComplete"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "off",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 23
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "FormControl"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "width"
              ],
              ": ",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "25ch",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 24
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "OutlinedInput"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "placeholder"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Please enter text",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 25
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "MyFormHelperText"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 26
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "FormControl"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 27
            },
            [
              "    </",
              [
                "span",
                "pl-ent",
                "form"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 29,
    "focusedLines": 6,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/FormControl",
      "@mui/material/OutlinedInput",
      "@mui/material/FormHelperText"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
